export default Object.freeze({
	/**
	 * Locales
	 */
	LOCALES: ['it', 'en'],

	/**
	 * Coupons
	 */
	COUPONS_TYPE_DISCOUNT_PERCENTAGE: 1,
	COUPONS_TYPE_DISCOUNT_AMOUNT: 2,
	COUPONS_TYPE_DISCOUNT_FIXED: 3,

	/**
	 * Credits
	 */
	CREDIT_AMOUNT_OPERATION: 1,
	CREDIT_AMOUNT_REGISTRATION: 10,
	CREDIT_AMOUNT_DEPOSIT_1: 5,
	CREDIT_AMOUNT_DEPOSIT_2: 11,
	CREDIT_AMOUNT_SHARED_CONTACTS: 3,
	CREDIT_TYPE_UNKNOWN: 0,
	CREDIT_TYPE_REGISTRATION: 1,
	CREDIT_TYPE_DEPOSIT: 2,
	CREDIT_TYPE_OPERATION: 3,
	CREDIT_TYPE_REFUND_DEPOSIT: 4,
	CREDIT_TYPE_REFUND_OPERATION: 5,
	CREDIT_TYPE_EXPIRE: 6,

	/**
	 * Feedbacks
	 */
	FEEDBACK_RATING_5: 5,
	FEEDBACK_RATING_4: 4,
	FEEDBACK_RATING_3: 3,
	FEEDBACK_RATING_2: 2,
	FEEDBACK_RATING_1: 1,

	/**
	 * Messages
	 */
	MESSAGE_FROM_USER: 1,
	MESSAGE_FROM_LAWYER: 2,
	MESSAGE_FROM_ADMIN: 9,
	MESSAGE_STATUS_PENDING: 0,
	MESSAGE_STATUS_APPROVED: 1,
	MESSAGE_STATUS_IGNORED: 7,
	MESSAGE_STATUS_REJECTED_1: 11,
	MESSAGE_STATUS_REJECTED_2: 12,
	MESSAGE_STATUS_REJECTED_3: 13,
	MESSAGE_STATUS_REPLIED: 99,

	/**
	 * Notifications
	 */
	NOTIFICATION_TYPE_GENERIC: 1,
	NOTIFICATION_TYPE_FROM_ADMIN: 2,
	NOTIFICATION_TYPE_ACCOUNT: 3,
	NOTIFICATION_TYPE_MONEY: 4,
	NOTIFICATION_TYPE_REQUEST: 5,
	NOTIFICATION_PRIORITY_LOW: 1,
	NOTIFICATION_PRIORITY_MEDIUM: 2,
	NOTIFICATION_PRIORITY_HIGH: 3,
	NOTIFICATION_PRIORITY_NONE: 99,

	/**
	 * Requests
	 */
	REQUEST_STATUS_CLOSED: 0,
	REQUEST_STATUS_INIT: 1,
	REQUEST_STATUS_NEW: 2,
	REQUEST_STATUS_WAIT: 3,
	REQUEST_STATUS_APPROVED: 5,
	REQUEST_STATUS_INCOMPLETE: 69,
	REQUEST_STATUS_REJECTED_1: 71,
	REQUEST_STATUS_REJECTED_2: 72,
	REQUEST_STATUS_REJECTED_3: 73,
	REQUEST_STATUS_REJECTED_WITH_REPLY: 79,
	REQUEST_STATUS_REFUNDED: 8,
	REQUEST_STATUS_RETIRED: 9,
	REQUEST_STATUS_INVALID_BY_DATA: 81,
	REQUEST_STATUS_INVALID_BY_OCCURRENCE: 82,
	REQUEST_PLAN_FREE: 1,
	REQUEST_PLAN_FREE_PRICE: 0,
	REQUEST_PLAN_BASIC: 2,
	REQUEST_PLAN_BASIC_PRICE: 2.99,
	REQUEST_PLAN_PREMIUM: 3,
	REQUEST_PLAN_PREMIUM_PRICE: 9.99,
	REQUEST_PLAN_TOP: 4,
	REQUEST_PART_DEMANDANT: 1,
	REQUEST_PART_RESPONDENT: 2,

	/**
	 * Responses
	 */
	RESPONSE_STATUS_PENDING: 1,
	RESPONSE_STATUS_NEW: 2,
	RESPONSE_STATUS_WAIT: 3,
	RESPONSE_STATUS_KO: 5,
	RESPONSE_STATUS_OK: 7,
	RESPONSE_STATUS_APPROVED: 9,

	/**
	 * Payments
	 */
	PAYMENTS_PAYPAL_SANDBOX_KEY: 'AWh5d-vdUb3zvBJtvkFB0o0M4QM_uvP6bcazcwN5YELrGPNOJcRj06A2K8Ijy-OFpcgy-3lM5KWUO5p_',
	PAYMENTS_PAYPAL_PRODUCTION_KEY: 'AS9TiABfoneC9DZAJqjpIUZcu9dF0fo7u7xFI0WOUP5pNcr150N9iViXmHA-l2NWxFxOe2USBqxO37uw',

	/**
	 * Defaults
	 */
	DEFAULT_DURATION_DAYS: 10,
	DEFAULT_LIMIT_TEXTAREA: 2000,
	DEFAULT_MAX_LANGUAGES: 10,
	DEFAULT_MAX_RESPONSES_OK: 5,
	DEFAULT_MAX_RESPONSES_KO: 5,
	DEFAULT_MAX_SKILLS: 4,
	DEFAULT_MIN_CHARS_KO: 50,
	DEFAULT_PAGE_NUMBER: 1,
	DEFAULT_PAGE_ITEMS: 10,
	DEFAULT_PREMIUM_REMIND_DAYS: 10,
	DEFAULT_REFUND_CREDITS_DAYS: 14,
	DEFAULT_REFUND_REQUEST_DAYS: 45,
	DEFAULT_EXTRA_APPROVAL_REQUEST_DAYS: 15,
	DEFAULT_FAKE_LAWYER_ID: '00000000-0000-0000-0000-000000000000',
	DEFAULT_FAKE_USER_ID: '11111111-1111-1111-1111-111111111111',

	/**
	 * Errors
	 */
	ERROR_GENERIC: 100,
	ERROR_PARAM_INVALID: 200,
	ERROR_FORBIDDEN_ACCESS_TYPE: 403,

	/**
	 * Endpoints
	 */
	ENDPOINT_BLACKLIST_VERIFY_ACCOUNTS: '/blacklist/verify/account',
	ENDPOINT_BLACKLIST_VERIFY_TEXT: '/blacklist/verify/text',

	/**
	 * Misc
	 */
	CUSTOM_REQUEST_STATUS_LOST: 30,
	COPYRIGHT_YEAR: '2022',
	COMPANY_MAIL_INFO: 'info@iuspopuli.it',
	COMPANY_MAIL_PEC: 'legal@pec.iuspopuli.it',
	COMPANY_NAME: 'Ius Populi S.r.l.',
	COMPANY_LEGAL_ADDRESS_FULL: 'Via Gattamelata 41, 20149 Milano, Italia',
	COMPANY_LEGAL_ADDRESS_STREET: 'Via Gattamelata, 41',
	COMPANY_LEGAL_ADDRESS_CAP: '20149',
	COMPANY_LEGAL_ADDRESS_CITY: 'Milano',
	COMPANY_PROJECT: 'Ius Populi',
	COMPANY_VAT: '12236830969',
	COMPANY_WEBSITE: 'https://www.iuspopuli.it',
	COMPANY_WEBSITE_TINY: 'iuspopuli.it',

	/**
	 * Partners
	 */
	PARTNERS: [
		{
			name: 'Arci Cosenza',
			link: 'https://www.arcicosenza.it/',
			image: '/static/images/partners/arci-cosenza.jpg',
			description:
				'<b>Arci</b> è una grande associazione culturale e di promozione sociale. Centinaia di migliaia di socie e soci e tantissime associazioni, circoli, case del popolo, società di mutuo soccorso in tutta Italia.<br />Nata nel 1957 a Firenze come organizzazione per la difesa e lo sviluppo di case del popolo e circoli ricreativi. Sono eredi della tradizione mutualistica dei movimenti popolari e antifascisti che hanno contribuito a costruire e consolidare la democrazia italiana fondata sulla Costituzione.<br />Oggi sono donne e uomini di tutte le età che credono nella libertà di associazione e nell’autorganizzazione democratica delle persone.<br />Sono schierati dalla parte della pace, dei diritti, dell’uguaglianza, della solidarietà, del libero accesso alla cultura, della giustizia sociale, dei valori democratici.',
		},
		{
			name: 'Anas',
			link: 'https://www.anasitalia.org/',
			image: '/static/images/partners/anas.jpg',
			description:
				'L’<b>A.N.A.S.</b> (Associazione Nazionale di Azione Sociale) è una rete associativa costituita da associazioni di promozione sociale, culturali, ricreative, comitati, cooperative sociali, imprese sociali, enti di mutuo soccorso e sportive. È presente sul territorio nazionale con oltre 700 articolazioni territoriali.<br />Quale Rete Associativa oltre a coordinare e supportare gli Enti del Terzo Settore affiliati, promuove e coordina attività sociali e culturali allo scopo di sviluppare e consolidare, anche in collaborazione con organi e istituzioni dello Stato, il processo democratico e civile della Repubblica.<br />Tale scopo, che si realizza soltanto attraverso la libera consapevole volontà dei singoli cittadini di arricchire la propria personalità morale, culturale e fisica, impegna l’A.N.A.S. a prendere iniziative che favoriscano la socialità nel pieno rispetto della persona umana e che siano ispirate a quei valori della cultura laica e libertaria cui l’Associazione storicamente si richiama.',
		},
	],

	/**
	 * Testimonials
	 */
	TESTIMONIALS: [
		{
			name: 'Roberta A.',
			date: '17/03/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Prima esperienza assolutamente positiva. È stato facile anche per me che non sono molto tecnologica.',
			more: '',
		},
		{
			name: 'Luca M.',
			date: '17/03/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Ho trovato un avvocato estremamente disponibile e preparato. Non ho anticipato nulla e non posso che consigliare questo sito.',
			more: '',
		},
		{
			name: 'Paola B.',
			date: '17/03/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Grande soddisfazione aver potuto ottenere il risarcimento che mi spettava per aver subito danni e beffe da un idraulico incapace e disonesto. Non credo mi sarei imbarcata in una causa senza il vostro servizio, troppi rischi e incognite. Con voi ho trovato <span id="dots1" class="dots">...</span><span id="more1" class="more">una adeguata e competente assistenza legale senza sostenere costi anticipati che mi sarebbero rimasti sul gobbo se non fossero state riconosciute le mie ragioni. Brutto subire un torto ma bello sapere di poterlo riparare in modo semplice e sicuro. Grazie di cuore</span>',
			more: '<a onclick="show_more(1)" id="moreLink1" class="moreLink">Leggi tutto</a>',
		},
		{
			name: 'Roberto F.',
			date: '17/03/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: "Un'esperienza inattesa. All'inizio ero un po' esitante per un servizio e un tipo di accordo cliente/avvocato di cui non ero a conoscenza. Ho provato e mi sono ricreduto completamente. Farò passaparola",
			more: '',
		},
		{
			name: 'Marina C.',
			date: '17/03/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Ero alla ricerca di un avvocato che mi potesse assistere senza dover pagare delle cifre proibitive. Con Ius populi sono riuscita a trovare un buon avvocato e un risparmio notevole. Tutto è andato a buon fine, altamente consigliabile.',
			more: '',
		},
		{
			name: 'Annalisa A.',
			date: '17/03/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: "Ottima prima esperienza! Non conoscevo questo sito e ho provato ad inviare una richiesta un po' per disperazione. Sono rimasta sorpresa per la velocità con cui gli avvocati hanno risposto. Ho trovato un avvocato serio e competente senza spendere niente. Davvero una soluzione perfetta, finalmente!",
			more: '',
		},
		{
			name: 'Chiara R.',
			date: '17/03/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Esperienza soddisfacente. Purtroppo ho ricevuto risposta da un solo studio legale, che però si è dimostrato molto bravo.',
			more: '',
		},
		{
			name: 'Francesco D.',
			date: '17/03/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Un sito molto utile. Il mio non era un grande problema ma il risultato è stato oltre le aspettative. Non posso che consigliare.',
			more: '',
		},
		{
			name: 'Gloria T.',
			date: '17/03/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Ho saputo di Ius Populi da un’amica: avevo da tempo una questione con i miei vicini di casa che ora ho finalmente risolto. Questo servizio è stata la mia fortuna, ho trovato un bravo avvocato che mi ha seguito con competenza e molta chiarezza. Senza anticipare nulla,<span id="dots2" class="dots">...</span><span id="more2" class="more"> l’ho pagato solo alla fine quando mi ha fatto vincere la causa. Grazie Ius Populi!</span>',
			more: '<a onclick="show_more(2)" id="moreLink2" class="moreLink">Leggi tutto</a>',
		},
		{
			name: 'Paolo A.',
			date: '17/03/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Esperienza estremamente positiva, devo ammettere che all’inizio ero titubante pensavo fosse una delle solite “promesse” che si trovano sui vari siti però mi son detto perché non provare, pochi euro per poter avere a disposizione diversi contatti che hanno valutato le <span id="dots3" class="dots">...</span><span id="more3" class="more">mie richieste, in pochi passaggi si completa la sessione con presa in carico di un legale che porta avanti la tua causa e il tutto senza sborsare un euro sembra fantascienza ma invece è così, molto efficace e semplice da utilizzare. Complimenti!</span>',
			more: '<a onclick="show_more(3)" id="moreLink3" class="moreLink">Leggi tutto</a>',
		},
		{
			name: 'Monica C.',
			date: '17/03/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Pienamente soddisfatta del supporto ricevuto dallo studio legale. L\'utilizzo della piattaforma è davvero semplice, in pochissimi passaggi ed in pochissimo tempo sono riuscita a trovare un bravo avvocato e risolvere un problema che mi tediava da anni <span id="dots4" class="dots">...</span><span id="more4" class="more">senza esser mai riuscita a trovare una soluzione. Molto consigliato!</span>',
			more: '<a onclick="show_more(4)" id="moreLink4" class="moreLink">Leggi tutto</a>',
		},
		{
			name: 'Giovanna C.',
			date: '17/03/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'È la prima volta che uso Ius Populi e prima non sapevo che si potesse fare questo accordo sul compenso con un avvocato. In pochissimo tempo ho ricevuto diverse risposte. Esperienza molto positiva. Grazie',
			more: '',
		},
		{
			name: 'Eleonora B.',
			date: '30/12/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Stanca di pagare per non avere nessuna certezza. Sono pienamente soddisfatta.',
			more: '',
		},
		{
			name: 'Francesca A.',
			date: '30/12/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Mi sono trovata molto bene. Avevo un problema urgente da risolvere, ho inviato una richiesta e nel giro di 24 h ho trovato un valido avvocato. Tutto molto efficiente, bel servizio davvero!',
			more: '',
		},
		{
			name: 'Iris P.',
			date: '30/12/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Tramite questa ottima piattaforma sono riuscita a trovare un bravissimo avvocato, molto disponibile e competente. Complimenti a Ius Populi che riesce a mettere in contatto chi ha bisogno di assistenza legale con seri professionisti.',
			more: '',
		},
		{
			name: 'Cesare C.',
			date: '30/12/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: "Esperienza positiva. Non ho avuto difficoltà nell'utilizzo della piattaforma e ho ricevuto risposte da diversi studi legali. Ne ho scelto uno che ha dimostrato la massima determinazione per tutelare i miei interessi e raggiungere il miglior risultato.",
			more: '',
		},
		{
			name: 'Andrea N.',
			date: '30/12/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Alla prima esperienza con Ius Populi il mio giudizio è positivo per la velocità e semplicità con cui si può affrontare la risoluzione di un proprio problema. Il servizio offerto da l’opportunità di mettersi in comunicazione con diversi studi legali e scegliere quello che <span id="dots5" class="dots">...</span><span id="more5" class="more">più corrisponde alle proprie esigenze. Da provare per tutti quelli che cercano assistenza legale.</span>',
			more: '<a onclick="show_more(5)" id="moreLink5" class="moreLink">Leggi tutto</a>',
		},
		{
			name: 'Lorenza M.',
			date: '30/12/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Ottima opportunità per trovare degli studi legali seri senza dover sostenere costi.',
			more: '',
		},
		{
			name: 'Filippo P.',
			date: '30/12/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Mi sono trovato molto bene. Ho inviato una richiesta e ho ricevuto tre risposte velocemente e quindi ho potuto scegliere a chi affidare l’incarico in due giorni.',
			more: '',
		},
		{
			name: 'Amir F.',
			date: '30/12/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Mi è piaciuto molto il servizio prestato. Grazie mille!',
			more: '',
		},
		{
			name: 'Paolo G.',
			date: '30/12/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Esperienza molto positiva perché ho trovato un valido professionista e risparmiato parecchi soldi. Consigliato',
			more: '',
		},
		{
			name: 'Riccardo B.',
			date: '30/12/2023',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Dopo lunghe e non risolutive ricerche in internet e quando ormai stavo esaurendo le speranze, ho trovato la soluzione che cercavo su Ius Populi. Ho trovato il servizio che cercavo e in tempi brevi ho potuto scegliere tra diversi studi legali.<span id="dots6" class="dots">...</span><span id="more6" class="more"> Ottima la risoluzione finale del mio problema. Consigliatissimo!</span>',
			more: '<a onclick="show_more(6)" id="moreLink6" class="moreLink">Leggi tutto</a>',
		},
		{
			name: 'Maria M.',
			date: '02/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Ottimo sito, ottimi professionisti, ottimo risparmio.',
			more: '',
		},
		{
			name: 'Ernesto M.',
			date: '02/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Ottimo sito, molto intuitivo e semplice. Ottimo anche l’avvocato che ho scelto per farmi assistere. Molto utile!',
			more: '',
		},
		{
			name: 'Mirko C.',
			date: '02/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Servizio TOP, ottima esperienza. Complimenti!',
			more: '',
		},
		{
			name: 'Daniela R.',
			date: '02/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Sono pienamente soddisfatta del servizio di Ius Populi, un ottimo sito con risposte rapide e un bel risparmio, Grazie!',
			more: '',
		},
		{
			name: 'Giulia A.',
			date: '02/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Ottima piattaforma per la ricerca di assistenza legale. La mia iniziale diffidenza nel trasmettere dati sensibili e personali attraverso un sito online e a persone sconosciute si è rivelata errata. Ho trovato tutto molto serio. Consiglio a tutti questa esperienza.',
			more: '',
		},
		{
			name: 'Giovanna D.',
			date: '02/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Ottimo sito, facile ed intuitivo. Non dover anticipare le spese legali è tanta roba e sono molto soddisfatta per come è stato risolto il mio problema. Fantastica questa opportunità!',
			more: '',
		},
		{
			name: 'Luca O.',
			date: '02/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Esperienza positiva. Sito intuitivo e chiaro, ottimo! Lo consiglio vivamente e si risparmia molto',
			more: '',
		},
		{
			name: 'Teresa M.',
			date: '02/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Avevo necessità di trovare, abbastanza urgentemente, assistenza legale. Ho deciso di intraprendere la strada online e sono rimasto molto soddisfatto. Ottimo servizio e ho risparmiato dei bei soldini. Per la mia esperienza assolutamente consigliato.',
			more: '',
		},
		{
			name: 'Andrea P.',
			date: '02/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'La comodità di fare tutto da casa senza muoversi, semplice nell’esecuzione. Si guadagna tempo e denaro',
			more: '',
		},
		{
			name: 'Enrico B.',
			date: '02/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Direi esperienza positiva. Ho trovato velocemente uno studio legale disposto a supportarmi e grazie a questa formula ho risparmiato non poco.',
			more: '',
		},
		{
			name: 'Omar H.',
			date: '03/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Esperienza positiva. Mi sono trovata benissimo e molto bene il risparmio economico. Posso solo ringraziarvi ed augurarvi di proseguire nel vostro ottimo lavoro.',
			more: '',
		},
		{
			name: 'Luciana P.',
			date: '03/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Funziona tutto perfettamente ed è la prima volta che riesco a risparmiare. Ottimo servizio, consigliato',
			more: '',
		},
		{
			name: 'Giuseppe L.',
			date: '03/01/2024',
			image: '/static/images/profile/user.png',
			role: 'Utente',
			text: 'Esperienza positiva, consiglio a tutti gli utenti che vogliono risparmiare.',
			more: '',
		},
	],
})



// WEBPACK FOOTER //
// ./src/config.js